import { inject, injectable } from 'inversify'
import 'reflect-metadata'
import { TYPES } from '../../../../common/domain/types'
import { IServiceSearch } from './IServiceSearch'
import type { ISearchRepository } from '../domain/ISearchRepository'
import { ResultadSearch } from '../domain/resultSearch'
import { SearchData, ProcData } from '../domain/search'




@injectable()
export class SearchService implements IServiceSearch {
  private readonly searchRepo: ISearchRepository

  public constructor (@inject(TYPES.SEARCH_REPOSITORY) _gestRepo: ISearchRepository) {
    this.searchRepo = _gestRepo
  }

  async search (applicationId: number, applicationversion: number, componentId: number, requestData: SearchData[], maxregs: number,componentDataSourceId?: number): (Promise<ResultadSearch>) {
    return await this.searchRepo.search(applicationId,applicationversion,componentId,requestData,maxregs,componentDataSourceId);
  }

  async searchLookUp (applicationId:number,applicationversion:number,lookUpId:number,requestData: SearchData[], maxregs : number): (Promise<ResultadSearch>) {
    return await this.searchRepo.searchLookUp(applicationId,applicationversion,lookUpId,requestData,maxregs);
  }


  async searchTablesViews (applicationId:number,applicationversion:number, databaseId: string,databaseTypeId:string): (Promise<ResultadSearch>) {
    return await this.searchRepo.searchTablesViews(applicationId,applicationversion, databaseId,databaseTypeId);
  }
  
  async searchFieldsTable (applicationId:number,applicationversion:number,databaseTypeId:string, databaseId:string, tableNames:string[]): (Promise<ResultadSearch>) {
    return await this.searchRepo.searchFieldsTable(applicationId,applicationversion,databaseTypeId,databaseId,tableNames);
  }

  async getPreviewData (applicationId:number,applicationversion:number,databaseTypeId:string, databaseId:string, querySelect:string, queryFrom:string, queryWhere:string, queryOrderBy:string, queryGroupBy:string, queryHaving:string, maxRegs:number): (Promise<ResultadSearch>) {
    return await this.searchRepo.getPreviewData(applicationId,applicationversion,databaseTypeId, databaseId, querySelect, queryFrom, queryWhere, queryOrderBy, queryGroupBy, queryHaving, maxRegs);
  }

  async searchProceduresAndFunctions (applicationId:number,applicationversion:number, databaseId: string,databaseTypeId:string): (Promise<ResultadSearch>) {
    return await this.searchRepo.searchProceduresAndFunctions(applicationId,applicationversion, databaseId,databaseTypeId);
  }
  
  async executeProcedureOrFunction (applicationId:number,applicationversion:number, databaseId: string,databaseTypeId:string,requestData: ProcData[]) : Promise<ResultadSearch>{
    return await this.executeProcedureOrFunction(applicationId,applicationversion, databaseId,databaseTypeId,requestData);
  }

}
